
import { defineComponent } from 'vue'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default defineComponent({
  components: { yandexMap, ymapMarker },
  setup() {
    const settings = { apiKey: '5ba10ad7-ffdb-457a-8a61-bb43e38c49b5' };
    return { settings }
  }
})
